export const ru = {
    'error-change-context': 'Не удалось сменить организацию',
    'error-com-sync': 'Ошибка синхронизации',
    'error-create': 'Не удалось создать организацию,\nпожалуйста выберите из списка или создайте новую',
    'error-fetch-organizations': 'Не удалось получить список организаций',
    'error-get-settings': 'Не удалось получить текущую организацию'
};
